
import { mapState } from 'vuex';
import { formatCurrency } from '@/utils/currency';

export default {
  name: 'MainHeader',

  data() {
    return {
      isAdvancedInputsShown: false,
    };
  },

  computed: {
    ...mapState({
      retirementAge: (state) =>
        state['pension-calculator'].inputs.slider_desired_retirement_age,

      gap: (state) => {
        const gap = state['pension-calculator'].outputs.pie_chart_pension_gap;
        return formatCurrency(gap, ' €');
      },
      optimalPension: (state) => {
        const income =
          state['pension-calculator'].outputs.pie_chart_required_pension;
        return formatCurrency(income, ' €');
      },

      isExampleData: (state) => state['pension-calculator'].isExampleData,
    }),

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    subheaderText() {
      const { optimalPension, gap, retirementAge } = this;

      const text = this.$t('subheader.mobile', {
        gap,
        optimalPension,
        retirementAge,
      });

      return !this.isExampleData
        ? text
        : `${this.$t('subheader.example')} ${text}`;
    },
  },

  methods: {
    handleEditDataButtonClick() {
      this.$emit('editClicked');

      this.$eventTrackClick('Website Pension Calculator Calculate Button', {
        Type: 'Edit link',
      });
    },
  },
};
